__turbopack_context__.v({
  "caption": "MediaCard-module__fTNx3a__caption",
  "card": "MediaCard-module__fTNx3a__card",
  "closeBtn": "MediaCard-module__fTNx3a__closeBtn",
  "galleryImage": "MediaCard-module__fTNx3a__galleryImage",
  "heyzineIframe": "MediaCard-module__fTNx3a__heyzineIframe",
  "homeMagazineCardWrapper": "MediaCard-module__fTNx3a__homeMagazineCardWrapper",
  "imageWrapperMagazine": "MediaCard-module__fTNx3a__imageWrapperMagazine",
  "imageWrapperPodcast": "MediaCard-module__fTNx3a__imageWrapperPodcast",
  "magazineButton": "MediaCard-module__fTNx3a__magazineButton",
  "magazineCardWrapper": "MediaCard-module__fTNx3a__magazineCardWrapper",
  "modalContainer": "MediaCard-module__fTNx3a__modalContainer",
  "modalOverlay": "MediaCard-module__fTNx3a__modalOverlay",
  "scrollCardWrapper": "MediaCard-module__fTNx3a__scrollCardWrapper",
  "youtubeIcon": "MediaCard-module__fTNx3a__youtubeIcon",
  "youtubePill": "MediaCard-module__fTNx3a__youtubePill",
});
